function cardHeader() {
    return {
        componentName: 'cardHeader',
        baseStyle: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        variants: {}
    };
}

export { cardHeader as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FyZEhlYWRlci5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3RoZW1lL2NvbXBvbmVudHMvY2FyZC9jYXJkSGVhZGVyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudFN0eWxlIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjYXJkSGVhZGVyKCk6IENvbXBvbmVudFN0eWxlIHtcbiAgcmV0dXJuIHtcbiAgICBjb21wb25lbnROYW1lOiAnY2FyZEhlYWRlcicsXG4gICAgYmFzZVN0eWxlOiB7XG4gICAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgICBqdXN0aWZ5Q29udGVudDogJ3NwYWNlLWJldHdlZW4nXG4gICAgfSxcbiAgICB2YXJpYW50czoge31cbiAgfTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFYyxTQUFVLFVBQVUsR0FBQTtJQUNoQyxPQUFPO0FBQ0wsUUFBQSxhQUFhLEVBQUUsWUFBWTtBQUMzQixRQUFBLFNBQVMsRUFBRTtBQUNULFlBQUEsT0FBTyxFQUFFLE1BQU07QUFDZixZQUFBLGNBQWMsRUFBRTtBQUNqQixTQUFBO0FBQ0QsUUFBQSxRQUFRLEVBQUU7S0FDWDtBQUNIOzs7OyJ9
